import { render } from "./Navbar.vue?vue&type=template&id=ffd9a5b8"
import script from "./Navbar.vue?vue&type=script&lang=js"
export * from "./Navbar.vue?vue&type=script&lang=js"

import "./Navbar.vue?vue&type=style&index=0&id=ffd9a5b8&lang=scss"
script.render = render

export default script